import React from 'react';
import { useClassNameMapper } from 'react-bootstrap';
import localStyles from './NodeSelectorDropdownItem.module.pcss';
import { SharedComponent } from '../../../enums';
import useTranslation from '../../useTranslation';
import type { NodePickerNode } from '../types';

interface Props {
  /** The node being rendered */
  node: NodePickerNode;
}

/**
 * Renders the title of the parent node or "Community" if the node is a direct child of the community node
 * @author Jonathan Bridges, Rosalyn Rowe
 */
const NodeSelectorDropdownItemSubtitle: React.FC<Props> = ({ node }) => {
  const cx = useClassNameMapper(localStyles);
  const { formatMessage, loading: textLoading } = useTranslation(
    SharedComponent.NODE_SELECTOR_DROPDOWN_ITEM
  );

  if (textLoading) {
    return null;
  }

  return (
    <span
      className={cx('lia-sub-title lia-g-clamp')}
      data-testid={`NodeSelectorDropDownItem.CategoryName.${node.id}`}
    >
      {node.depth === 1 ? formatMessage('communityNode') : node.parent?.title}
    </span>
  );
};

export default NodeSelectorDropdownItemSubtitle;
